module.exports = __webpack_public_path__ + "static/media/schedule_structure_change_rotating_period_name.973cca74.mov";